import { DateTime } from "luxon";

import { StoppageTypeDto } from "./StoppageTypeDto";
import { StoppageSubTypeDto } from "./StoppageSubTypeDto";
import { LocationDTO } from "../Production/LocationDTO";
import { PlantDTO } from "../Plants/PlantDTO";
import { DetectionSource } from "../apiEnums.generated";

export class StoppageDto {
  stoppageId?: number;
  plantId!: number;
  plant?: PlantDTO;
  startTime!: DateTime;
  endTime?: DateTime;
  workOrder?: string;
  repairsFaults?: string;
  whoWorkedOnIt?: string;
  bookedUpBy?: string;
  bookedUpDateTime?: DateTime;
  stoppageTypeId!: number;
  stoppageType?: StoppageTypeDto;
  stoppageSubTypeId!: number;
  stoppageSubType?: StoppageSubTypeDto;
	incident!: boolean;
	locationId?: number;
  location?: LocationDTO;
  hasImages?: boolean;
  rowVersion?: string;
  detectionSource?: DetectionSource;
  // Note: undefined on a row this client built itself (an offline entry, or a payload assembled for an
  // edit), which is a row a person entered. Only an explicit false means telemetry wrote it unchecked.
  isVerified?: boolean;

  constructor(data: StoppageDto) {
    Object.assign(this, data);
  }
}
